import store from '../store';

/**
 * Whether the current venue has GV (Gift Voucher) only access.
 * Any plan whose obeePlan starts with 'voucher_' is treated as GV-only.
 */
export const isGvOnlyAccount = () => {
  const user = store.getState()?.user;
  const isObeeStaff = user?.obeeUserLinkedVenues?.data?.loggedInUser?.obee_staff === '1';
  const isECBSStaff = user?.userInfo?.userType === 'staff';
  const isStaff = isObeeStaff || isECBSStaff;

  const plan = store.getState()?.restaurantActive?.restaurant?.obeePlan;

  // Staff accounts should not be treated as GV-only, even if the linked venue is GV-only, to allow them to access all pages for support purposes.
  return isStaff ? false : typeof plan === 'string' && plan.startsWith('voucher_');
};

/** Page ids that GV-only users are allowed to access (view dropdown + route guard). */
export const GV_ONLY_ALLOWED_PAGE_IDS = ['voucherRedemptions', 'guestbook', 'settings'];

/** Default path for GV-only users when redirecting (e.g. initial load or disallowed route). */
export const GV_ONLY_DEFAULT_PAGE_SLUG = '/voucher-redemptions';
